import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import ErrorMessage from "../../../form/ErrorMessage";
import { reserveYourStopSchema } from "../../../../utils/schema";
import Loader from "../../../loader";
import { reserveSpot } from "../../../../redux/features/coach/actions/authAction";

const ReserveYourSpot = ({ setIsModal, data, page = "" }) => {
    const {isLoading}  = useSelector(state=>state.coach.auth)
  const dispatch = useDispatch();
  const initialState = {
    name: "",
    email: "",
    notes: "",
  };

  const handleFormSubmission = (values) => {
    const payload = {
      ...values,
      id: data[page == "nuterra" ? "nuterra_id" : "workshop_id"],
      type: page,
    };
    const callback = (res) => {
      if (res?.success) {
        setIsModal(false);
      }
    };

    dispatch(reserveSpot({payload,callback}))
  };

  if(isLoading){
    return <Loader/>
  }
  return (
    <div
      className="modal d-block modal-lg ct_congratulation_modal_fade"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered ct_modal-dialog">
        <div className="modal-content ">
          <div className="modal-header border-0">
            <button
              type="button"
              className="btn-close ct_circle_close"
              onClick={() => {
                setIsModal(false);
              }}
            ></button>
          </div>
          <div className="modal-body px-0">
            <h4 className="ct_fw_600 mb-1 ct_fs_20 ct_darksky_blue_text px-4 text-center">
              You're Almost In
            </h4>
            <p className="mb-0 ct_grey_text px-4 text-center">
              Save your seat now-it's free and only takes a few seconds
            </p>
            <Formik
              initialValues={initialState}
              enableReinitialize
              validationSchema={reserveYourStopSchema}
              onSubmit={(values, actions) => {
                handleFormSubmission(values);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => (
                <form
                  action={handleSubmit}
                  className="mt-4  px-5 "
                >
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">Name</label>
                        <input
                          type="text"
                          className="form-control ct_input "
                          placeholder="Enter name"
                          id="name"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.name}
                        ></input>
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"name"}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">Email</label>
                        <input
                          type="email"
                          className="form-control ct_input "
                          placeholder="Enter email"
                          id="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.email}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"email"}
                        />
                      </div>
                    </div>
                   

                    <div className="col-md-12">
                      <div className="form-group mb-4">
                        <label className="d-block mb-2">Notes(Optional)</label>
                        <textarea
                          rows="2"
                          className="form-control ct_input h-auto"
                          id="notes"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values?.notes}
                        />
                        <ErrorMessage
                          errors={errors}
                          touched={touched}
                          fieldName={"notes"}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-3 justify-content-center pt-4">
                    <button
                      className="ct_sky_blue_btn ct_yellow_btn px-5 py-2"
                      type="button"
                      onClick={handleSubmit}
                    >
                      Confirm My Spot
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReserveYourSpot;
